import Wrapper from 'xpi-black-ui/Base/Wrapper';
import ContentBox from 'xpi-black-ui/Base/ContentBox';
import styled from 'styled-components';

const WrapperMain = styled(Wrapper).attrs(() => ({ innerWrapper: true }))`
  padding: 0 !important;
`;

export default WrapperMain;

export const WrapperContentBoxFooter = styled(ContentBox)`
  padding-top: 0 !important;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
`;

export const WrapperContentBoxChildren = styled(ContentBox)`
  overflow-x: auto;
  padding-top: 0 !important;
  border-radius: 0;
`;

export const WrapperFooter = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.5rem;
`;

export const WrapperHeader = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 3rem;
  padding-right: 0.5rem;
`;

export const WrapperHeaderUpdate = styled.div`
  display: flex;
  margin-bottom: 0.2rem;
`;
